import { Component, OnInit } from "@angular/core";
import { StaticPageGetByPageKeyOutputDTO } from "src/app/models/contents.models/staticPage.models/staticPageGetByPageKeyOutputDTO.model";
import { SiteSEOHelperService } from "src/app/services/siteseoHelper.service";
import { StaticPagesSiteService } from "src/app/services/staticPagesSite.service";
import { ColleaguesSiteService } from "src/app/services/colleaguesSite.service";
import { ColleagueGetListOutputDTO } from "src/app/models/informations.models/colleague.models/colleagueGetListOutputDTO.model";
import { DResult } from "src/app/models/common.models/dresult.model";
import { API_ServerAddress } from "src/app/MyAppCommonConfig";

@Component({
  selector: "colleagues",
  templateUrl: "colleagues.component.html"
})
export class ColleaguesComponent implements OnInit {
  ngOnInit(): void {
    this.GetCommonPage();
    this.GetColleagues();
  }

  APIServerAddress: string = API_ServerAddress;
  pageKey: string = "ColleaguesIndex";
  commonPage: StaticPageGetByPageKeyOutputDTO = new StaticPageGetByPageKeyOutputDTO();
  colleagues: ColleagueGetListOutputDTO[] = [];

  constructor(
    private siteSEOHelperService: SiteSEOHelperService,
    private staticPagesSiteService: StaticPagesSiteService,
    private colleaguesSiteService: ColleaguesSiteService
  ) {}

  GetCommonPage() {
    this.staticPagesSiteService
      .GetByPageKey(this.pageKey)
      .subscribe((data: DResult<StaticPageGetByPageKeyOutputDTO>) => {
        if (data.isSuccess) {
          this.commonPage = data.result;

          this.siteSEOHelperService.SetPageMetaData(
            this.commonPage.metaTitle,
            this.commonPage.metaDescription,
            this.commonPage.metaKeywords
          );
        }
      });
  }

  GetColleagues() {
    this.colleaguesSiteService
      .GetList()
      .subscribe((data: DResult<ColleagueGetListOutputDTO[]>) => {
        if (data.isSuccess) {
          this.colleagues = data.result.sort((a, b) => a.showPriority < b.showPriority ? -1 : a.showPriority > b.showPriority ? 1 : 0);
        }
      });
  }
}
